module.exports = __webpack_public_path__ + "assets/images/tutorial5.072a0bd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial5.png
// module id = 456
// module chunks = 1